
import {api_host} from '../common/constants'

export const deleteSubmit = (obj, paso, dia, error, muestra, perf, tiempo ) => 
    fetch(api_host+`/reporte/especial/deleteDayMovistar/?obj=${obj}&paso=${paso}&dia=${dia}&error=${error}&muestra=${muestra}&perf=${perf}&tiempo=${tiempo}&token=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E3`)
.then(response => response.json() )

export const deleteHistoric = (objetivo_id, mes, prfDel,errorDel,parcialDel) =>     
    fetch(api_host+`/reporte/especial/deleteHistoricMovistar/?objetivo_id=${objetivo_id}&mes=${mes}&prfDel=${prfDel}&errorDel=${errorDel}&parcialDel=${parcialDel}&token=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E3`)
.then(response => response.json())



// WEBPACK FOOTER //
// ./src/services/deleteSubmit.jsx